export default "__VITE_ASSET__maWBrlXJ__"